import { render, staticRenderFns } from "./HotelsEdit.vue?vue&type=template&id=57b97e3a&"
import script from "./HotelsEdit.vue?vue&type=script&lang=js&"
export * from "./HotelsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports